import {
  START_LOADING_SHAREPOINT_PROCESSED_FILES,
  SHAREPOINT_PROCESSED_FILES_LOAD_SUCCESS,
  SHAREPOINT_PROCESSED_FILES_LOAD_FAILED,
  START_RUNNING_MISA_TASK,
  MISA_TASK_RUN_SUCCESS,
  MISA_TASK_RUN_FAILED,
} from '../actions/types';

const initialState = {
  loadingSharePointProcessedFiles: false,
  sharePointProcessedFiles: [],
  runningMisaTask: false
};

const sharePointProcessedFileReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case START_LOADING_SHAREPOINT_PROCESSED_FILES:
      return {
        ...state,
        loadingSharePointProcessedFiles: true
      };
    case SHAREPOINT_PROCESSED_FILES_LOAD_SUCCESS:
      return {
        ...state,
        loadingSharePointProcessedFiles: false,
        sharePointProcessedFiles: Array.isArray(payload.data) ? payload.data : []
      };
    case SHAREPOINT_PROCESSED_FILES_LOAD_FAILED:
      return {
        ...state,
        loadingSharePointProcessedFiles: false
      };
    case START_RUNNING_MISA_TASK:
      return {
        ...state,
        runningMisaTask: true
      };
    case MISA_TASK_RUN_SUCCESS:
    case MISA_TASK_RUN_FAILED:
      return {
        ...state,
        runningMisaTask: false
      };
    default:
      return state;
  }
};

export default sharePointProcessedFileReducer;
